import React, { useState } from 'react';
import { emailService } from '../services/emailService';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';

export default function EmailTest() {
  const [formData, setFormData] = useState({
    email: 'oluwole.aguda@gmail.com',
    fullName: 'Test User',
    companyName: 'Test Company',
    applicationId: 'TEST-' + Date.now(),
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e?.target?.name]: e?.target?.value,
    });
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      const result = await emailService?.sendRegistrationEmail({
        email: formData?.email,
        fullName: formData?.fullName,
        companyName: formData?.companyName || undefined,
        applicationId: formData?.applicationId || undefined,
      });

      setStatus({
        type: 'success',
        message: `✅ Email sent successfully! Email ID: ${result?.emailId}`,
      });
    } catch (error) {
      setStatus({
        type: 'error',
        message: `❌ Failed to send email: ${error?.message}`,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">
            📧 Email Test Utility
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            Test registration email delivery system
          </p>
        </div>

        <div className="bg-white shadow-md rounded-lg p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Recipient Email *
              </label>
              <Input
                type="email"
                name="email"
                value={formData?.email}
                onChange={handleChange}
                required
                placeholder="recipient@example.com"
                className="w-full"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Full Name *
              </label>
              <Input
                type="text"
                name="fullName"
                value={formData?.fullName}
                onChange={handleChange}
                required
                placeholder="John Doe"
                className="w-full"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Company Name (Optional)
              </label>
              <Input
                type="text"
                name="companyName"
                value={formData?.companyName}
                onChange={handleChange}
                placeholder="Company Name"
                className="w-full"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Application ID (Optional)
              </label>
              <Input
                type="text"
                name="applicationId"
                value={formData?.applicationId}
                onChange={handleChange}
                placeholder="APP-12345"
                className="w-full"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full"
            >
              {loading ? 'Sending...' : '🚀 Send Test Email'}
            </Button>
          </form>

          {status?.message && (
            <div
              className={`mt-4 p-4 rounded-md ${
                status?.type === 'success' ?'bg-green-50 text-green-800 border border-green-200' :'bg-red-50 text-red-800 border border-red-200'
              }`}
            >
              <p className="text-sm font-medium">{status?.message}</p>
            </div>
          )}

          <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-md">
            <h3 className="text-sm font-semibold text-blue-900 mb-2">
              📋 Prerequisites Checklist:
            </h3>
            <ul className="text-xs text-blue-800 space-y-1">
              <li>✓ Resend API key configured in Supabase secrets</li>
              <li>✓ Edge Function deployed successfully</li>
              <li>✓ Sender email verified in Resend dashboard</li>
              <li>✓ CORS enabled for Edge Function</li>
            </ul>
          </div>

          <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-md">
            <h3 className="text-sm font-semibold text-yellow-900 mb-2">
              ⚠️ Important Notes:
            </h3>
            <ul className="text-xs text-yellow-800 space-y-1">
              <li>• Check spam/junk folder if email doesn't arrive</li>
              <li>• Free Resend accounts: 100 emails/day limit</li>
              <li>• Using test domain: onboarding@resend.dev</li>
              <li>• Replace with verified domain for production</li>
            </ul>
          </div>
        </div>

        <div className="mt-6 text-center">
          <a
            href="/"
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
}